const TERMINAL_PRIMARY_FONT = "HackGen Console NF";

export const TERMINAL_FONT_LOAD_TIMEOUT_MS = 2000;
export const TERMINAL_FALLBACK_FONT_FAMILY = '"Geist Mono", monospace';
export const TERMINAL_FONT_FAMILY = `"${TERMINAL_PRIMARY_FONT}", ${TERMINAL_FALLBACK_FONT_FAMILY}`;
export const TERMINAL_FONT_SIZE = 12;
/**
 * 端末の行送り (文字サイズに対する倍率)。等幅の桁送りに合わせた端末固有の指標であり、
 * 本文の行送りトークンとは独立に決める。
 */
export const TERMINAL_LINE_HEIGHT = 1.25;

export interface TerminalFontLoad {
	/** タイムアウトまでに読み込めたか。false の場合は fallback フォントのみで open する。 */
	readonly ready: Promise<boolean>;
	/** 読み込みの最終結果。タイムアウト後に遅れて解決することがある。 */
	readonly settled: Promise<boolean>;
}

/**
 * ターミナルフォントの読み込みを開始する。xterm がセル寸法を再計測するのは open 時、行列数が
 * 変わる resize 時、fontFamily/fontSize の変更時だけなので、fallback フォントの寸法で fit した
 * 後に webfont が適用されると 1 行が高くなり下端が切れたままになる。そのため読み込み完了まで
 * open を待つ。タイムアウトした場合や取得に失敗した場合は fallback フォントのみで open し、
 * 遅れて読み込めたときに呼び出し側が fontFamily を差し替えて再計測させる。
 */
export function loadTerminalFont(fonts: FontFaceSet): TerminalFontLoad {
	const settled = fonts.load(`${TERMINAL_FONT_SIZE}px "${TERMINAL_PRIMARY_FONT}"`).then(
		(faces) => faces.length > 0,
		// 取得できなくてもターミナル自体は fallback フォントで正常に動作するため、そのまま続行する。
		() => false,
	);
	let timer: ReturnType<typeof setTimeout> | undefined;
	const timedOut = new Promise<boolean>((resolve) => {
		timer = setTimeout(() => resolve(false), TERMINAL_FONT_LOAD_TIMEOUT_MS);
	});
	const ready = Promise.race([settled, timedOut]).finally(() => clearTimeout(timer));
	return { ready, settled };
}
